module.exports = __webpack_public_path__ + "img/35264215.1fa80c43.png";